import { when } from 'cerebral/factories'
import { saveEntities } from '../factories'
import { showFeedback } from '../feedback/factories'
import { sequences as route } from '../route'
import * as actions from './actions'
import { moduleState } from 'cerebral'

export const find = [
  actions.find,
  actions.setHasOverride,
  actions.expandHoursToSchedule,
  saveEntities(),
  actions.collectTags,
]

export const findForList = [
  ({ props }) => ({ useRouteParams: props.useRouteParams !== false }),
  actions.find,
  actions.expandHoursToSchedule,
  actions.setHasOverride,
  actions.setList,
  saveEntities(),
  actions.collectTags,
]

export const get = [
  actions.get,
  actions.setHasOverride,
  actions.expandHoursToSchedule,
  saveEntities(),
]

export const save = [
  actions.save,
  actions.setHasOverride,
  saveEntities(),
]

export const saveAndReturn = [
  actions.setHoursFromSchedule,
  actions.save,
  actions.setHasOverride,
  saveEntities(),
  showFeedback({ title: 'Lift saved', type: 'success' }),
  route.toLifts,
]

export const clearAllOverrides = [
  actions.clearAllOverrides,
  actions.setHasOverride,
  saveEntities(),
  showFeedback({ title: 'Overrides cleared', type: 'success' }),
]

export const checkTags = [
  when(moduleState`allTags`, (allTags) => allTags?.length === 0),
  {
    true: find,
    false: [],
  },
]
